import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import AddEditForm from '../components/addEditForm.vue';

var AddSeaFreightBookingPage = function (_super) {
  __extends(AddSeaFreightBookingPage, _super);

  function AddSeaFreightBookingPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddSeaFreightBookingPage = __decorate([Component({
    components: {
      AddEditForm: AddEditForm
    }
  })], AddSeaFreightBookingPage);
  return AddSeaFreightBookingPage;
}(Vue);

export default AddSeaFreightBookingPage;